// Why the wizard cannot go past a step, in words, or null when it can.
import { messages } from "../../i18n";
import { requirementLabel } from "../../workflows/requirements/model";
import { type Draft, missingBindings, missingToolchains, type StepKey, sourceProblem, stepReady } from "./draft";

export function stepProblem(d: Draft, step: StepKey): string | null {
  if (stepReady(d, step)) return null;
  const t = messages().tasks.create.problems;
  switch (step) {
    case "type":
      return t.type;
    case "workflow":
      return t.workflow;
    case "source": {
      const problem = sourceProblem(d);
      return problem ? t[problem] : null;
    }
    case "access": {
      const toolchains = missingToolchains(d).map((toolchain) => requirementLabel({ kind: "toolchain", toolchain }));
      return t.access([...missingBindings(d).map((m) => requirementLabel(m.requirement)), ...toolchains].join(", "));
    }
    case "review":
      return d.name.trim() === "" ? t.name : t.parallel;
  }
}
